import { Box, Typography } from "@mui/material";
import React from "react";
import { useTranslations } from "next-intl";

interface ItinerarySummaryRowProps {
  days?: number;
  nights?: number;
  meals?: number;
}

const ItinerarySummaryRow = ({ days, nights, meals }: ItinerarySummaryRowProps) => {
  const t = useTranslations("PDP");

  return (
    <Box
      sx={{ display: "flex", alignItems: "center", gap: "34px" }}
      data-testid="itinerary-summary-info"
    >
      <Box
        data-testid="itinerary-days"
        sx={{
          paddingRight: "24px",
          borderRight: (theme) => `1px solid ${theme.palette.divider}`,
          display: "flex",
          flexDirection: "column",
          gap: "0.8rem"
        }}
      >
        <Typography
          sx={{
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: "700",
            lineHeight: "150%",
            letterSpacing: "0.4px",
            color: "secondary.main"
          }}
          data-testid="itinerary-days-label"
        >
          {t("DAYS")}
        </Typography>
        <Typography
          sx={{
            fontSize: "24px",
            fontWeight: "500",
            lineHeight: "36px",
            letterSpacing: "0.4px"
          }}
          data-testid="itinerary-days-number"
        >
          {days}
        </Typography>
      </Box>
      <Box
        data-testid="itinerary-nights"
        sx={{
          paddingRight: "24px",
          borderRight: (theme) => `1px solid ${theme.palette.divider}`,
          display: "flex",
          flexDirection: "column",
          gap: "0.8rem"
        }}
      >
        <Typography
          sx={{
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: "700",
            lineHeight: "150%",
            letterSpacing: "0.4px",
            color: "secondary.main"
          }}
          data-testid="itinerary-nights-label"
        >
          {t("NIGHTS")}
        </Typography>
        <Typography
          sx={{
            fontSize: "24px",
            fontWeight: "500",
            lineHeight: "36px",
            letterSpacing: "0.4px"
          }}
          data-testid="itinerary-nights-number"
        >
          {nights}
        </Typography>
      </Box>
      {meals !== undefined && meals > 0 && (
        <Box
          sx={{ paddingRight: "24px", display: "flex", flexDirection: "column", gap: "8px" }}
          data-testid="itinerary-meals"
        >
          <Typography
            sx={{
              fontSize: "16px",
              fontStyle: "normal",
              fontWeight: "700",
              lineHeight: "150%",
              letterSpacing: "0.4px",
              color: "secondary.main"
            }}
            data-testid="itinerary-meals-label"
          >
            {t("MEALS")}
          </Typography>
          <Typography
            sx={{
              fontSize: "24px",
              fontWeight: "500",
              lineHeight: "36px",
              letterSpacing: "0.4px"
            }}
            data-testid="itinerary-meals-number"
          >
            {meals}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default ItinerarySummaryRow;
